import { render, staticRenderFns } from "./TuPortalAccessBadge.vue?vue&type=template&id=21672d37&functional=true"
import script from "./TuPortalAccessBadge.vue?vue&type=script&lang=js"
export * from "./TuPortalAccessBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports